import { request } from './request'
// 模板列表
export const getTaskTemplateList = data =>
  request('/portal/verify/waf/task/templateList', {
    method: 'post',
    data,
  })

export const getRecentlyUpdate = data =>
  request('/portal/verify/waf/task/templateResourceLatest', {
    params: {
      ...data,
    },
  })

export interface GetTemplateDetail {
  template_id?: string
}
export const getTemplateDetail = (data: GetTemplateDetail) =>
  request('/portal/verify/waf/task/templateResourceList', {
    params: {
      ...data,
    },
  })
// 任务详情
export const getTaskInfo = data =>
  request('/portal/verify/waf/results/getResultTaskInfo', {
    params: {
      ...data,
    },
  })

export const getChartsInfo = data =>
  request('/portal/verify/waf/results/detail', {
    params: {
      ...data,
    },
  })

export const getExecuteData = data =>
  request('/portal/verify/waf/results/detail/execution/time', {
    params: {
      ...data,
    },
  })

export const getExecuteType = data =>
  request('/portal/verify/waf/results/detail/execution/type', {
    params: {
      ...data,
    },
  })

export const getSerial = data =>
  request('/portal/verify/waf/results/detail/serial', {
    params: {
      ...data,
    },
  })

export const getProgress = data =>
  request('/portal/verify/waf/results/detail/progress', {
    params: {
      ...data,
    },
  })

export const getProgressPayload = data =>
  request('/portal/verify/waf/results/detail/progress/payload', {
    params: {
      ...data,
    },
  })

export const getProgressPayloadLog = data =>
  request('/portal/verify/waf/results/detail/progress/payload/request', {
    params: {
      ...data,
    },
  })
export const getFailPayloadLog = data =>
  request('/portal/verify/waf/results/detail/progress/payload/failed', {
    params: {
      ...data,
    },
  })
// 模板拦截失败率低于20
export const getTemplateFailRate = data =>
  request('/portal/verify/waf/results/detail/interception/failure/template', {
    params: {
      ...data,
    },
  })
// 攻击防护排名
export const getProtectRate = data =>
  request('/portal/verify/waf/results/detail/attack/protect/success/rate', {
    params: {
      ...data,
    },
  })

// 解码能力
export const getEncodeRate = data =>
  request('/portal/verify/waf/results/detail/encode/success/rate', {
    params: {
      ...data,
    },
  })

// 任务评分
export const getTaskScore = data =>
  request('/portal/verify/waf/results/detail/score', {
    params: {
      ...data,
    },
  })
// 拦截失败率
export const getFailRate = data =>
  request('/portal/verify/waf/results/detail/interception/failed/rate', {
    params: {
      ...data,
    },
  })
// 获取解码失败率
export const getRiskLevels = data =>
  request('/portal/verify/waf/results/detail/interception/failed/encode/rate', {
    params: {
      ...data,
    },
  })
// 获取危险等级分布
export const getRiskRate = data =>
  request('/portal/verify/waf/results/detail/risk/rate', {
    params: {
      ...data,
    },
  })

// 获取影响组件分布
export const getComponent = data =>
  request('/portal/verify/waf/results/detail/component', {
    params: {
      ...data,
    },
  })

export const getDeviceAlarm = data =>
  request('/portal/verify/waf/results/detail/log/deviceAlarm', {
    timeout: 10000,
    params: {
      ...data,
    },
  })

// 获取解码失败率
export const getDecodeRate = data =>
  request('/portal/verify/waf/results/detail/interception/failed/encode/rate', {
    params: {
      ...data,
    },
  })
// 获取分组列表
export interface GetTemplate {
  ID?: string
  type?: number
  search?: string
  keyword?: string
}
export const getTemplate = (data: GetTemplate) =>
  request('/portal/verify/waf/resource/getTemplateList', {
    params: {
      ...data,
    },
  })
// 新增自定义模板
export interface PostPayloadsGroup {
  name: string
}
export const postPayloadsGroup = (data: PostPayloadsGroup) =>
  request('/portal/verify/waf/resource/template', {
    method: 'post',
    data,
  })
// 新增自定义分组
export interface PutPayloadsGroup {
  name: string
  id: string
}
export const putPayloadsGroup = (data: PutPayloadsGroup) =>
  request('/portal/verify/waf/resource/template/payloads_group', {
    method: 'put',
    data,
  })
// 删除自定义分组
export interface DeletePayloadsGroup {
  template_id: string[]
}
export const deletePayloadsGroup = (data: DeletePayloadsGroup) =>
  request('/portal/verify/waf/resource/template', {
    method: 'DELETE',
    data,
  })
// 新增自定义模板
export interface PostTemplate {
  name: string
  cover?: string
  group_ids?: string[]
}
export const postTemplate = (data: PostTemplate) =>
  request('/portal/verify/waf/resource/createTemplate', {
    method: 'post',
    data,
  })
// 修改自定义分组
export interface PutTemplate {
  name: string
  id: string
  group_ids?: string[]
}
export const putTemplate = (data: PutTemplate) =>
  request('/portal/verify/waf/resource/updateTemplate', {
    method: 'put',
    data,
  })
// 删除自定义模板
export interface DeleteTemplate {
  ids: string[]
}
export const deleteTemplate = (data: DeleteTemplate) =>
  request('/portal/verify/waf/resource/batchDeleteTemplate', {
    method: 'delete',
    data,
  })
export interface BatchConfigPayload {
  template_id: string
  payload_ids: string[]
}

export const batchBindPayload = (data: BatchConfigPayload) =>
  request('/portal/verify/waf/resource/batchBindPayload', {
    method: 'post',
    data,
  })

export const batchUnbindPayload = (data: BatchConfigPayload) =>
  request('/portal/verify/waf/resource/batchUnBindPayload', {
    method: 'post',
    data,
  })

//获取站点资源列表
export interface GetSiteList {
  search?: string
  size: number
  page: number
}
export const getSiteList = (data: GetSiteList) =>
  request('/portal/verify/waf/resource/site/list', {
    method: 'post',
    data,
  })
// 获取站点资源详细
export interface GetDetail {
  id: string
}
export const getDetail = (data: GetDetail) =>
  request('/portal/verify/waf/resource/site/detail', {
    params: data,
  })

// 删除站点资源
export interface DeleteSite {
  id?: string[]
}
export const deleteSite = (data: DeleteSite) =>
  request('/portal/v1/waf/site', {
    method: 'DELETE',
    params: data,
  })
// 站点认证
export interface SiteVerify {
  ID: string
}
export const siteVerify = (data: SiteVerify) =>
  request('/portal/verify/waf/resource/site/verify', {
    method: 'post',
    data,
  })
// 网址认证
export interface SiteDial {
  url: string
}
export const siteDial = (data: SiteDial) =>
  request('/portal/verify/waf/resource/site/dial', {
    method: 'post',
    data,
  })

// 添加站点资源
export interface WafTask {
  task_name: string
  url: string
  template_ids: string[]
  day?: number[]
  time?: string
  option: number
  proxy?: string
}

export const wafTask = data =>
  request('/portal/verify/waf/task/createTask', {
    method: 'post',
    data,
    timeout: 15 * 1000, // 15秒超时
  })
// 添加站点资源

/**
 * basbas_commonv1AddWafSiteRequest
 */
export interface CreateTaskData {
  site?: V1WafSiteData
  [property: string]: any
}

/**
 * v1WafSiteData
 */
export interface V1WafSiteData {
  /**
   * repeated string site_name = 15;，业务域id
   */
  areaId?: string
  authMode?: V1AuthMode
  autoUpdateFirm?: BasbasCommonv1SwitchStatus
  /**
   * 影响组件id
   */
  component?: string[]
  /**
   * 1无配置 2组件+无配置 3全部
   */
  componentSwitch?: number
  cookieAuth?: string
  cookieRefreshFrequency?: BasbasCommonv1CookieRefreshFrequency
  db?: string
  defaultVerifyDevice?: string[]
  deviceIdList?: string[]
  /**
   * string waf_name = 12;
   */
  fileName?: string
  language?: string
  os?: string
  protocolAuth?: BasbasCommonv1ProtocolAuth
  randomString?: string[]
  /**
   * 备注
   */
  remark?: string
  site?: string[]
  /**
   * 0.DNS验证 1.字符串验证 2.授权验证 3.后台验证
   */
  type?: number
  userId?: string
}

export const createTask = (data: CreateTaskData) =>
  request('/portal/v1/waf/site', {
    method: 'post',
    data,
  })
// 修改站点资源
export interface EditSiteData {
  site?: V1WafSiteData
  [property: string]: any
}

/**
 * v1WafSiteData
 */
export interface V1WafSiteData {
  /**
   * repeated string site_name = 15;，业务域id
   */
  areaId?: string
  authMode?: V1AuthMode
  autoUpdateFirm?: BasbasCommonv1SwitchStatus
  /**
   * 影响组件id
   */
  component?: string[]
  /**
   * 1无配置 2组件+无配置 3全部
   */
  componentSwitch?: number
  cookieAuth?: string
  cookieRefreshFrequency?: BasbasCommonv1CookieRefreshFrequency
  db?: string
  defaultVerifyDevice?: string[]
  deviceIdList?: string[]
  /**
   * string waf_name = 12;
   */
  fileName?: string
  language?: string
  os?: string
  protocolAuth?: BasbasCommonv1ProtocolAuth
  randomString?: string[]
  /**
   * 备注
   */
  remark?: string
  site?: string[]
  /**
   * 0.DNS验证 1.字符串验证 2.授权验证 3.后台验证
   */
  type?: number
  userId?: string
  [property: string]: any
}

/**
 * - AuthModeNo: 无认证
 * - AuthModeProtocolAuth: 协议认证
 * - AuthModeCookieAuth: cookie认证
 */
export enum V1AuthMode {
  AuthModeCookieAuth = 'AuthModeCookieAuth',
  AuthModeNo = 'AuthModeNo',
  AuthModeProtocolAuth = 'AuthModeProtocolAuth',
}

/**
 * basbas_commonv1SwitchStatus
 */
export enum BasbasCommonv1SwitchStatus {
  SwitchStatusOff = 'SwitchStatusOff',
  SwitchStatusOn = 'SwitchStatusOn',
  SwitchStatusUnknown = 'SwitchStatusUnknown',
}

/**
 * basbas_commonv1cookieRefreshFrequency
 */
export interface BasbasCommonv1CookieRefreshFrequency {
  /**
   * cookie获取-指定频率（秒）
   */
  cookieRefreshSeconds?: number
  cookieRefreshType?: BasbasCommonv1CookieRefreshFrequencycookieRefreshType
  [property: string]: any
}

/**
 * - payload_frequency: payload频率
 * - customizable_frequency: 指定频率
 */
export enum BasbasCommonv1CookieRefreshFrequencycookieRefreshType {
  CustomizableFrequency = 'customizable_frequency',
  PayloadFrequency = 'payload_frequency',
  Unknown = 'unknown',
}

/**
 * basbas_commonv1ProtocolAuth
 */
export interface BasbasCommonv1ProtocolAuth {
  password?: string
  username?: string
  [property: string]: any
}

export const editTask = (data: EditSiteData) =>
  request('/portal/verify/waf/resource/site/edit', {
    method: 'put',
    data,
  })
// 获取安全域和站点

// export const getArea = () => request('/portal/verify/waf/task/area')
export const getArea = () => request('/portal/verify/waf/task/targetList')

export const getAttckList = () => request('/portal/verify/waf/task/attck')

// 获取编码类型列表
export const getEnctype = () => request('/portal/verify/waf/task/template/enctype')

// export const getProxy = () => request('/portal/verify/waf/task/proxy')
export const getProxy = () => request('/portal/verify/waf/task/taskProxyList')
// 获取操作系统列表

export const getSiteOs = () => request('/portal/verify/waf/resource/os')
// 站点设备配置日志模式获取设备
export const getSiteDeviceList = () =>
  request('/portal/verify/waf/resource/site/logDevice/deviceList')

// 获取数据库列表

export const getSiteDb = () => request('/portal/verify/waf/resource/db')

export const getSiteLang = () => request('/portal/verify/waf/resource/language')

// 获取waf类型

export const getSiteType = () => request('/portal/verify/waf/resource/waf_type')

// waf厂商认证
export interface PostIdentification {
  url: string
}
export const postIdentification = (data: PostIdentification) =>
  request('/portal/verify/waf/resource/waf/identification', {
    method: 'post',
    data,
  })

// 获取代理池列表
export interface GetAgentPool {
  search?: string
}
export const getAgentPool = (data: GetAgentPool) =>
  request('/portal/verify/waf/proxy/pool', {
    params: {
      ...data,
    },
  })

// 删除代理池
export interface DeleteAgentPool {
  pool_id: string[]
}
export const deleteAgentPool = (data: DeleteAgentPool) =>
  request('/portal/verify/waf/proxy/pool', {
    method: 'DELETE',
    data,
  })
// 添加代理池
export interface PostAgentPool {
  name: string
  pool_id?: string
}
export const postAgentPool = (data: PostAgentPool) =>
  request('/portal/verify/waf/proxy/pool', {
    method: 'post',
    data,
  })

export const putAgentPool = (data: PostAgentPool) =>
  request('/portal/verify/waf/proxy/pool', {
    method: 'put',
    data,
  })

// 添加代理
export interface PostProxy {
  pool_id: string
  ip: string[]
}
export const postProxy = (data: PostProxy) =>
  request('/portal/verify/waf/proxy/ip', {
    method: 'post',
    data,
  })
// 编辑代理
export interface PutProxy {
  proxy_id?: string
  pool_id?: string
  ip?: string
}
export const putProxy = (data: PutProxy) =>
  request('/portal/verify/waf/proxy/ip', {
    method: 'put',
    data,
  })
// 删除代理
export interface DelProxy {
  pool_id: string
  proxy_id: string[]
}
export const delProxy = (data: DelProxy) =>
  request('/portal/verify/waf/proxy/ip', {
    method: 'DELETE',
    data,
  })

// 获取代理
export interface GetProxy {
  search?: string
  pool_id: string
  limit: number
  page: number
}
export const getProxyList = (data: GetProxy) =>
  request('/portal/verify/waf/proxy/ip', {
    params: {
      ...data,
    },
  })

// 获取payload列表
export interface GetPayloads {
  keyword?: string | null
  template_id?: string | null
  attack_type?: string | null
  update_time?: string | null
  method?: number | null
  risk_level?: number | null
  limit: number
  page: number
  component_id?: string | null
  tag_ids?: string[] | null
}
export const getPayloads = (data: GetPayloads) =>
  request('/portal/verify/waf/resource/getPayloadList', {
    method: 'post',
    data,
  })

// 获取已绑定payload
export const getBoundPayloads = (data: GetPayloads) =>
  request('/portal/verify/waf/resource/getBoundPayloadList', {
    method: 'post',
    data,
  })

// 获取已绑定payload
export const getUnboundPayloads = (data: GetPayloads) =>
  request('/portal/verify/waf/resource/getUnboundPayloadList', {
    method: 'post',
    data,
  })
// 删除payload
export interface DeletePayloads {
  ids: string[]
}
export const deletePayloads = (data: DeletePayloads) =>
  request('/portal/verify/waf/resource/batchDeletePayload', {
    method: 'delete',
    data,
  })
// 批量导入
export interface Loadcsv {
  // template_id: number
  items_1: {}[]
  items_2: {}[]
  items_3: string[]

  // payload_del: number[]
  // payload_insert: {}[]
  // payload_update: {}[]
}
export const loadcsv = (data: Loadcsv) =>
  request('/portal/verify/waf/resource/batchCreatePayload', {
    method: 'post',
    data,
  })

export const DownloadCsv = (data: Loadcsv) =>
  request('/portal/verify/waf/resource/template/payloads/download/csv/data', {
    method: 'post',
    data,
  })
// 添加payload
export interface PostPayloads {
  template_id?: string
  payload: string
  name?: string
  attack_type: string
  risk_level: number
  method: number
  parameter?: string
  os?: number
  db?: number
  language?: number
  cve?: string
  cnnvd?: string
  waf_firm?: string
  headers?: any
  describe?: string
  solution?: string
  path?: string
  content_type?: string
}
export const postPayloads = data =>
  request('/portal/verify/waf/resource/createPayload', {
    method: 'post',
    data,
  })
// 修改payload
export interface PutPayloads {
  id: string
  payload: string
  method: number
  // parameter?: string
  os?: number
  database?: number
  risk_level: number
  headers?: any
  describe?: string
  solution?: string
  waf_firm?: string
  // header_str?: string
}
export const putPayloads = (data: PutPayloads) =>
  request('/portal/verify/waf/resource/updatePayload', {
    method: 'PUT',
    data,
  })
// 获取payload详情
export interface GetPayloadDetail {
  id: string
}
export const getPayloadDetail = (data: GetPayloadDetail) =>
  request('/portal/verify/waf/resource/getPayloadDetail', {
    params: {
      ...data,
    },
  })
// 获取payload筛选条件模版列表
export interface GetDropDown {
  result_id: string | undefined
}
export const getDropDown = (data: GetDropDown) =>
  request('/portal/verify/waf/results/template/drop_down', {
    params: {
      ...data,
    },
  })
// payload列表详情
export interface GetRequest {
  task_payload_id: string
  result_id?: string
}
export const getRequest = (data: GetRequest) =>
  request('/portal/verify/waf/results/detail/payload/list/request', {
    params: {
      ...data,
    },
  })

export const getLog = (data: GetRequest) =>
  request('/portal/verify/waf/results/detail/payload/getPayloadLog', {
    params: {
      ...data,
    },
  })

export const getDevices = data =>
  request('/portal/verify/waf/results/detail/log/device', {
    params: {
      ...data,
    },
  })

export const getComponents = data =>
  request('/portal/verify/waf/results/getComponent', {
    params: {
      ...data,
    },
  })

export const getResourceComponent = data =>
  request('/portal/verify/waf/resource/component', {
    params: {
      ...data,
    },
  })

//校验payload名称是否存在
export const checkedPayload = data =>
  request('/portal/verify/waf/resource/checkPayloadNameExists', {
    method: 'post',
    data,
  })

//编辑时校验payload名称是否存在
export const checkedEditPayload = data =>
  request('/portal/verify/waf/resource/checkUpdatePayloadExists', {
    method: 'post',
    data,
  })

// 获取攻击类型
export const getAttackTypes = data =>
  request(`/portal/verify/waf/results/${data.resultId}/attack_type`)

// 获取开发语言
export const getLanguage = () => request('/portal/verify/waf/resource/language')
// 获取用户domain
export const getUserDomain = () => request('/portal/verify/waf/resource/site/user_domain')

// 下载授权文件
export interface Download {
  site: string
}
export const download = (data: Download) =>
  request('/portal/verify/waf/auth_pdf/download', {
    responseType: 'blob',
    params: {
      ...data,
    },
  })

// 下载上传的授权文件
export interface DownloadAuth {
  file_name: string
}
export const downloadAuth = (data: DownloadAuth) =>
  request('/portal/verify/waf/resource/site/download/auth', {
    responseType: 'blob',
    params: {
      ...data,
    },
  })
export interface CheckSiteName {
  site_name: string
  site_id: string
}
export const checkSiteName = (data: CheckSiteName) =>
  request('/portal/verify/waf/resource/site/checkSiteName', {
    method: 'post',
    data,
  })
export const getSiteArea = () => request('/portal/verify/waf/resource/site/area')

// 影响组件
export const getComponentList = () => request('/portal/verify/waf/common/component')

export const downloadFailedFile = data =>
  request('/portal/verify/waf/resource/site/downloadFailedFile', { method: 'post', data })

export const downloadTemplate = () =>
  request('/portal/verify/waf/resource/site/importTemplateDownload', { method: 'post' })

export const checkWafSite = data =>
  request('/portal/verify/waf/resource/site/checkWafSite', { method: 'post', data })

// 树结构标签选项
export const getTagTreeOptions = data =>
  request(`/portal/verify/waf/bind_tag_list`, {
    params: {
      ...data,
    },
  })

// 树结构标签选项
export const getTagTreeSnapshotOptions = data =>
  request(`/portal/verify/waf/tag_snapshot_filter`, {
    params: {
      ...data,
    },
  })

// 获取离线日志导入信息
export const getOfflineLogInfo = data =>
  request(`/portal/v1/waf/results/${data}/get_log_device_import_records`)

// 删除日志设备导入记录
export const deleteOfflineLogInfo = data =>
  request(`/portal/v1/waf/results/${data.resultId}/log_device_import_record/${data.id}`, {
    method: 'DELETE',
    timeout: 90000,
  })

// 修改拦截状态
export const updateInterceptStatus = data =>
  request(`/portal/verify/waf/result/resourceIntercept/${data.id}`, {
    method: 'PUT',
    data: data.list,
  })

// 站点资源指纹信息列表
export const getFingerprint = (params: { originType?: number }) =>
  request('/portal/v1/waf/fingerprint', {
    params,
  })

// 站点资源列表
export const getSiteResourceList = (data: GetSiteList) =>
  request('/portal/v1/waf/site', {
    method: 'get',
    params: {
      ...data,
    },
  })

// 添加站点资源
// export const createTaskV1 = (data: CreateTaskData) =>
//   request('/portal/v1/waf/site', {
//     method: 'post',
//     data,
//   })

export const createTaskV1 = (data: CreateTaskData) =>
  request('/portal/v1/waf/site', {
    method: 'post',
    data,
  })

// 修改站点资源
export const editTaskV1 = (data: EditSiteData) =>
  request(`/portal/v1/waf/site/${data.id}`, {
    method: 'put',
    data: { site: data?.site },
  })

// 站点资源详情
export const getDetailV1 = (data: GetDetail) => request(`/portal/v1/waf/site/${data.id}`)

// -------------------------2.0.1--------------------------------
// 获取编码类型列表
export const getEncTypeList = () => request('/portal/v1/waf/encode_type')

// 获取关联安全设备
export interface GetSecurityDevice {
  /**
   * 站点id
   */
  siteId: string
  [property: string]: any
}

export const getSecurityDevice = (data: GetSecurityDevice) =>
  request(`/portal/v1/waf/site/${data.siteId}/device`)

// 获取模板列表
export interface GetTemplateList {
  /**
   * 模板名字
   */
  'filterParams.name'?: string
  /**
   * 来源类型
   *
   * - OriginTypeSystem: 系统内置
   * - OriginTypeCustom: 手动添加
   */
  'filterParams.originType'?: FilterParamsOriginType
  /**
   * 关联场景ids
   */
  'filterParams.sceneIds'?: number[]
  /**
   * 排序字段
   *
   * - TemplateSortFieldUpdateTime: 更新时间
   * - TemplateSortFieldResourceAmount: 用例数量
   */
  'filterParams.sortField'?: FilterParamsSortField
  /**
   * 排序方式
   *
   * - SortOrderUnspecified: 默认值，未指定排序方式
   * - SortOrderAscending: 正序
   * - SortOrderDescending: 倒序
   */
  'filterParams.sortOrder'?: FilterParamsSortOrder
  /**
   * 验证模式ids
   */
  'filterParams.verificationModeIds'?: number[]
  /**
   * 页码
   */
  page?: number
  /**
   * 页大小
   */
  pageSize?: number
  [property: string]: any
}
/**
 * 来源类型
 *
 * - OriginTypeSystem: 系统内置
 * - OriginTypeCustom: 手动添加
 */
export enum FilterParamsOriginType {
  OriginTypeCustom = 'OriginTypeCustom',
  OriginTypeSystem = 'OriginTypeSystem',
  OriginTypeUnknown = 'OriginTypeUnknown',
}

/**
 * 排序字段
 *
 * - TemplateSortFieldUpdateTime: 更新时间
 * - TemplateSortFieldResourceAmount: 用例数量
 */
export enum FilterParamsSortField {
  TemplateSortFieldResourceAmount = 'TemplateSortFieldResourceAmount',
  TemplateSortFieldUnknown = 'TemplateSortFieldUnknown',
  TemplateSortFieldUpdateTime = 'TemplateSortFieldUpdateTime',
}

/**
 * 排序方式
 *
 * - SortOrderUnspecified: 默认值，未指定排序方式
 * - SortOrderAscending: 正序
 * - SortOrderDescending: 倒序
 */
export enum FilterParamsSortOrder {
  SortOrderAscending = 'SortOrderAscending',
  SortOrderDescending = 'SortOrderDescending',
  SortOrderUnspecified = 'SortOrderUnspecified',
}

export const getTemplateList = (data: GetTemplateList) =>
  request('/portal/common/resourceTemplates', {
    method: 'post',
    data,
  })

export interface GetCaseList {
  /**
   * 攻击类型id
   */
  'filterParams.attackTypeId'?: string
  /**
   * 用例名称
   */
  'filterParams.name'?: string
  /**
   * 来源类型
   *
   * - OriginTypeSystem: 系统内置
   * - OriginTypeCustom: 手动添加
   */
  'filterParams.originType'?: FilterParamsOriginType
  /**
   * 用例分级
   *
   * - ResourceLevelJunior: 初级
   * - ResourceLevelMiddle: 中级
   * - ResourceLevelSenior: 高级
   */
  'filterParams.resourceLevel'?: FilterParamsResourceLevel
  /**
   * 危险等级
   *
   * - RiskLevelLow: 低危
   * - RiskLevelMiddle: 中危
   * - RiskLevelHigh: 高危
   * - RiskLevelGross: 严重
   */
  'filterParams.riskLevel'?: FilterParamsRiskLevel
  /**
   * 排序字段
   */
  'filterParams.sortField'?: FilterParamsSortField
  /**
   * 排序方式
   *
   * - SortOrderUnspecified: 默认值，未指定排序方式
   * - SortOrderAscending: 正序
   * - SortOrderDescending: 倒序
   */
  'filterParams.sortOrder'?: FilterParamsSortOrder
  /**
   * 标签ids
   */
  'filterParams.tagId'?: string[]
  'filterParams.templateId'?: string[]
  /**
   * 验证模式id
   */
  'filterParams.verificationModeId'?: number
  /**
   * 页码
   */
  page?: number
  /**
   * 页大小
   */
  pageSize?: number
  templateId?: string[]
  [property: string]: any
}

/**
 * 来源类型
 *
 * - OriginTypeSystem: 系统内置
 * - OriginTypeCustom: 手动添加
 */

/**
 * 用例分级
 *
 * - ResourceLevelJunior: 初级
 * - ResourceLevelMiddle: 中级
 * - ResourceLevelSenior: 高级
 */
export enum FilterParamsResourceLevel {
  ResourceLevelJunior = 'ResourceLevelJunior',
  ResourceLevelMiddle = 'ResourceLevelMiddle',
  ResourceLevelSenior = 'ResourceLevelSenior',
  ResourceLevelUnknown = 'ResourceLevelUnknown',
}

/**
 * 危险等级
 *
 * - RiskLevelLow: 低危
 * - RiskLevelMiddle: 中危
 * - RiskLevelHigh: 高危
 * - RiskLevelGross: 严重
 */
export enum FilterParamsRiskLevel {
  RiskLevelGross = 'RiskLevelGross',
  RiskLevelHigh = 'RiskLevelHigh',
  RiskLevelLow = 'RiskLevelLow',
  RiskLevelMiddle = 'RiskLevelMiddle',
  RiskLevelUnknown = 'RiskLevelUnknown',
}

// 获取关联用例列表
export const getCaseList = (data: GetCaseList) =>
  request(`/portal/common/resourceTemplate/resources`, {
    method: 'post',
    data,
  })

export interface SaveCaseToTemplate {
  /**
   * 描述
   */
  description?: string
  /**
   * 模板名字
   */
  name?: string
  /**
   * 关联用例ids
   */
  resourceIds?: string[]
  /**
   * 关联场景ids
   */
  sceneIds?: string[]
  /**
   * 验证模式ids
   */
  verificationModeIds?: string[]
  [property: string]: any
}

// 保存已选择用例为模板
export const saveCaseToTemplate = (data: SaveCaseToTemplate) =>
  request(`/portal/common/resourceTemplate`, {
    method: 'post',
    data,
  })

// 定义接口类型
export enum V1ResourceCenterOriginType {
  OriginTypeCustom = 'OriginTypeCustom',
  OriginTypeSystem = 'OriginTypeSystem',
  OriginTypeUnknown = 'OriginTypeUnknown',
}

export interface V1GetResourceTemplateListReplyTemplateItem {
  description?: string
  name?: string
  originType?: V1ResourceCenterOriginType
  resourceAmount?: number
  resourceIds?: string[]
  sceneIds?: number[]
  updateTime?: Date
  verificationModeIds?: number[]
  [property: string]: any
}

export interface TemplateResponse {
  list?: V1GetResourceTemplateListReplyTemplateItem[]
  total?: number
  [property: string]: any
}

export interface GetCaseDetail {
  resourceId: string
}

export const getCaseDetail = (data: GetCaseDetail) =>
  request(`/portal/common/resource/waf/${data.resourceId}`, {
    method: 'get',
  })

// 获取所有模板id
export const getAllTemplateId = (data: GetTemplateList) =>
  request('/portal/common/resourceTemplates/ids', {
    method: 'post',
    data,
  })

// 获取所有用例id
export const getAllCaseId = (data: GetCaseList) =>
  request('/portal/common/resourceTemplate/filterResourceIds', {
    method: 'post',
    data,
    timeout: 8 * 1000,
  })

// 获取站点分析概览
export const getSiteAnalyzeOverview = () =>
  request('/portal/v1/sites_overview', {
    method: 'get',
  })

// 站点操作系统分布
export interface SiteOsDistributionItem {
  count?: number
  osName?: string
  [property: string]: any
}

export const getSiteOsDistribution = (): Promise<{ list: SiteOsDistributionItem[] }> =>
  request('/portal/v1/sites_overview/os_distribution', {
    method: 'get',
  }).then(res => res.data)

// 站点影响组件分布
export interface SiteComponentDistributionItem {
  count?: number
  componentName?: string
  [property: string]: any
}
export const getSiteComponentDistribution = (): Promise<{
  list: SiteComponentDistributionItem[]
}> =>
  request('/portal/v1/sites_overview/component_distribution', {
    method: 'get',
  }).then(res => res.data)

// 获取站点设备筛选列表
export const getSiteDeviceFilterList = () =>
  request('/portal/v1/devices_by_site', {
    method: 'get',
  })

// 攻击类型
export const getAttackTypeList = data =>
  request('/portal/common/attack/attack_type_filter_list', {
    method: 'get',
    params: data,
  })

// 获取用例标签
export const getResourceTagList = data =>
  request('/portal/common/resources/tag/list', {
    method: 'post',
    data,
  })

// 获取创建站点安全设备列表
export const getCreateSiteSecurityDeviceList = () =>
  request('/portal/v1/devices_by_type', {
    method: 'get',
  })

// 根据templateIds获取resourceIds
export const getResourceIdsByTemplateIds = data =>
  request('/portal/common/resourceTemplate/filter/ResourceIds', {
    method: 'post',
    data,
  })

// 获取执行失败用例列表
export const getFailedCaseList = data =>
  request(`/portal/verify/waf/result/${data.resultId}/sentFailedCaseList`, {
    method: 'get',
  })

// 获取未执行用例列表
export const getUnsentCaseList = data =>
  request(`/portal/verify/waf/result/${data.resultId}/unsentCaseList`, {
    method: 'get',
  })

// 获取任务结果日志
export const getTaskResultLog = data =>
  request(`/portal/verify/waf/results/detail/payload/getPayloadLog`, {
    method: 'get',
    params: data,
  })

// 获取验证结果(图表)
export const getVerifyResult = data =>
  request(`/portal/v1/waf/verify_result_distribution`, {
    method: 'get',
    params: data,
  })

// 危险等级分布（图表）
export const getRiskLevelDistribution = data =>
  request(`/portal/v1/waf/risk_level_distribution`, {
    method: 'get',
    params: data,
  })

// 攻击防护排名（图表）
export const getAttackProtectionRanking = data =>
  request(`/portal/v1/waf/attack_protection_ranking`, {
    method: 'get',
    params: data,
  })

// 设备防护能力排名
export const getDeviceProtectionRanking = data =>
  request(`/portal/v1/waf/tasks/${data.resultId}/device_defence`, {
    method: 'get',
  })

// 模板防护失效排名
export const getTemplateProtectionFailureRanking = data =>
  request(`/portal/v1/waf/tasks/${data.resultId}/template_statistic`, {
    method: 'get',
  })

// 用例等级分布
export const getCaseLevelDistribution = data =>
  request(`/portal/v1/waf/tasks/${data.resultId}/resource_level_distribution`, {
    method: 'get',
  })

// 获取用例分级筛选数据
export const getResourceFilterData = data =>
  request(`/portal/v1/waf/tasks/${data.resultId}/filter_data`, {
    method: 'get',
  })

export interface UpdateConfigSite {
  defaultVerifyDevice?: string[]
  deviceIdList?: string[]
  id?: string[]
  [property: string]: any
}

// 更新站点
export const updateConfigSite = (data: UpdateConfigSite) =>
  request('/portal/v1/site/device/update', {
    method: 'post',
    data,
  })
